<template>
<div >
  <div class="width_100 horizontal h_center" style="position: fixed; top: 0; z-index: 1;">
    <div class="container" style="background: white; width: 100%;max-width: 480px;">
<!--      <div class="page_title" >{{$t('menu.interest')}}</div>-->
      <b-tabs class="tab_bar" v-model="tab" fill>
        <b-tab :title="$t('interest.recently_view')" active title-link-class="tab_text tab"></b-tab>
        <b-tab :title="$t('interest.favorite_sale')"  title-link-class="tab_text tab"></b-tab>
      </b-tabs>
    </div>
  </div>
  <div class="container scroll" @scroll="onScroll" ref="wrap" style="width: 480px; padding-top: 4em;padding-bottom: 6em; overflow: auto;height: 100vh;">
    <SiteItem v-for="item in dataList"
              :item="item"
              :showBtn="true"
              @like="onLike"
              @completeReport="onCompleteReport"
    />
    <div class="quick_btn_wrapper" style="margin-left: 480px">
      <b-button
        pill
        class="quick_btn align-horizontal center p-0"
        style="background-color: transparent"
        @click="showSearchDlg()"
      >
        <b-img :src="require('../../../../assets/image/ic_qb_search@2x.png')"/>
      </b-button>
      <b-button
        pill
        class="quick_btn align-horizontal center p-0"
        style="background-color: transparent"
        @click="
          $store.commit('setTabIndex', self.$c.MAIN_TAB.MORE);
          $store.commit('setTmpTabIndex', '');
          ut.navigate(self, '/SaleList');"
      >
        <b-img :src="require('../../../../assets/image/ic_qb_sale_list@2x.png')"/>
      </b-button>
      <b-button
        pill
        class="quick_btn align-horizontal center p-0"
        style="background-color: transparent"
        @click="showSaleRegisterPopup = true"
      >
        <b-img :src="require('../../../../assets/image/ic_qb_sale_regist@2x.png')"/>
      </b-button>
    </div>
  </div>
  <SiteReportPopup
  :visible.sync="showSiteReportPopup"
  :item="currentItem"
  />
  <Navbar />
  <SiteRegisterPopup :visible.sync="showSaleRegisterPopup" />
  <SearchPopup :visible.sync="showSearchPopup" @search="onSearchPopup"/>
  <SiteInquiry v-if="inquiryKeyword != null" :visible.sync="showSiteInquiryPopup" :keyword="inquiryKeyword" />
</div>
</template>

<script>
import Navbar from '../../../controls/navbar'
import SiteItem from "../../../controls/SiteItem";
import Utils from "../../../../config/utils";
import SiteRegisterPopup from "../../../controls/popup/SiteRegisterPopup";
import {IS_UI_MODE} from "../../../../config/constant";
import SiteReportPopup from "../../../controls/popup/SiteReportPopup";
import SearchPopup from "../../../controls/popup/SearchPopup.vue";
import SiteInquiry from '../interest/SiteInquiry.vue';

const TAB= {
  RECENT: 0,
  LIKE: 1,
}

export default {
  name: "Interest",
  components: {
    SiteReportPopup,
    Navbar,
    SiteItem,
    SiteRegisterPopup,
    SearchPopup,
    SiteInquiry
  },
  data: function() {
    return {
      tab:0,
      loadingEnd:false,
      dataList:[],
      pageNum:1,
      currentItem:null,
      showSiteReportPopup:false,
      showSaleRegisterPopup:false,
      self: this,
      ut: Utils,
      showSearchPopup:false,
      showSiteInquiryPopup:false,
      inquiryKeyword:null,
    }
  },
  methods:{
    showSearchDlg() {
      this.showSearchPopup = true;
    },
    onSearchPopup(item) {
      this.inquiryKeyword = item;
      this.showSiteInquiryPopup = true;
    },
    getList() {
      if (this.loadingEnd) {
        return;
      }

      if (IS_UI_MODE) {
        this.dummyData();
        return;
      }

      if (this.$store.getters.isLoading) {
        return;
      }

      Utils.requestGet(
        this.tab == TAB.RECENT? this.$c.API.Site.getRecentViewSiteList : this.$c.API.Site.getLikeSiteList,
        {
          page_num: this.pageNum,
        },
      ).then(result => {

        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.loadingEnd = result.data.count > result.data.list.length;
          this.pageNum = ++this.pageNum;
          this.dataList = this.dataList.concat(result.data.list);
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    initList(){
        this.pageNum = 1;
        this.loadingEnd = false;
        this.dataList = [];
      this.getList();
    },
    onCell(item){
      Utils.requestGet(
        this.$c.API.Site.getSiteDetail,
        {
          site_idx: item.f_idx,
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          // NavigationService.navigate('SiteDetail', {
          //   site: result.data,
          // });
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onLike(item){
      if (this.tab == TAB.LIKE) {
        this.dataList =  this.dataList.filter(it => {
          return it.f_idx != item.f_idx;
        });
      }
    },

    onScroll(){
      let wrap = this.$refs.wrap;
      // console.log(wrap.scrollHeight);
      // console.log(wrap.scrollTop);
      // console.log(wrap.clientHeight);
      if(wrap.scrollHeight - Math.ceil(wrap.scrollTop) === wrap.clientHeight){ //end of scroll
        if (!this.loadingEnd)
        this.getList();
      }
    },

    onCompleteReport(item){
      this.currentItem = item;
      this.showSiteReportPopup = true;
    },

    dummyData() {
      let list = [];
      for (let ind = 0; ind < 10; ind++) {
        list.push({
          f_idx: ind,
          f_reg_time: '2021.03.03',
          f_open_date: '2021.03.03',
          f_site_type: ['O', 'G'][ind % 2], //Site Type (O: New Open Maemul, G: General Maemul)
          f_name: `JianPalace ADong ${ind + 1}`,
          f_address1: 'address1',
          f_address2: 'address2',
          f_maemul_type: '0,1',
          f_dong_count: ind + 1,
          f_household_count: ind + 1,
          f_parking_type: 'String : Parking Info(Mulit Select)(split with [,])',
          f_transaction_type: 'String : Transaction Type(Mulit Select)(split with [,])',
          f_sale_price_min: 1050000000,
          f_sale_price_max: 3020000000,
          f_safe_charter: ['Y', 'N'][ind % 2],
          f_smb: ['Y', 'N'][ind % 2],
          f_charter_price_min: 1050000000,
          f_charter_price_max: 3020000000,
          f_invest_price_min: 30000000,
          f_invest_price_max: 50000000,
          f_monthly_rent_deposit: 10000,
          f_monthly_rent_min: 105000,
          f_monthly_rent_max: 302000,
          f_elevator: ['Y', 'N'][ind % 2],
          f_memo: 'The lighting is good toward the south. This is the 10th floor of the Royal Floor.',
          f_image_urls: '',
          f_remain_days_till_hide: 6,
        });
      }
    },
  },
  mounted() {
    this.$store.commit('setTabIndex', this.$c.MAIN_TAB.INTEREST);
    this.initList();
  },
  watch:{
    tab(){
      this.initList();
    }
  },
}
</script>

<style scoped lang="scss">
  @import '../../../../assets/css/main/interest/Interest.scss';
  .page_title{
    color: $black;
    font-size: $fs_22;
    font-family: $korean_gd_15_r;
    text-align: center;
    padding: 1em 0;
  }
 </style>



// WEBPACK FOOTER //
// src/components/contents/main/interest/Interest.vue